import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import RenderBlock from "../utils/render-block"
import SEO from "../components/seo"
import ProductDetail from "../components/Product/ProductDetail"

const product = ({ data, addVariantToCart, checkout, pageContext }) => {
  const { shopifyProduct, wpProduct } = data

  return (
    <>
      <SEO
        path={`/shop/${shopifyProduct.handle}/`}
        title={shopifyProduct.title}
        description={shopifyProduct.description}
      />
      <div className="product-details">
        <ProductDetail
          product={shopifyProduct}
          addVariantToCart={addVariantToCart}
          checkout={checkout}
          wpProduct={wpProduct}
          sellingPlan={pageContext?.selling_plan}
        />
      </div>
      {wpProduct?.acf?.contentBlocks?.map((el, i) =>
        RenderBlock(el.fieldGroupName, el, i, "product", addVariantToCart)
      )}
    </>
  )
}

product.propTypes = {
  data: PropTypes.object.isRequired,
  addVariantToCart: PropTypes.func.isRequired,
  removeLineItemInCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
}

export default product

export const postQuery = graphql`
  query ShopifyProductById($slug: String!) {
    shopifyProduct(handle: { eq: $slug }) {
      id
      shopifyId
      handle
      title
      description
      descriptionHtml
      publishedAt
      productType
      requiresSellingPlan
      priceRange : priceRangeV2 {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      tags
      variants {
        title
        shopifyId
        storefrontId
        legacyResourceId
        price
        selectedOptions {
          name
          value
        }
      }
      images {
        id
        originalSrc
      }
    }
    wpProduct(slug: { eq: $slug }) {
      product_details {
        howToUse
        ingredients
        shippingAndReturns
      }
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      acf {
        contentBlocks {
          ... on WpProduct_Acf_ContentBlocks_EcoConcious {
            fieldGroupName
            backgroundColor
            description
            heading
            imageToTheLeft
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            icon {
              sourceUrl
              localFile {
                publicURL
              }
            }
          }
          ... on WpProduct_Acf_ContentBlocks_CustomerReviewsSection {
            fieldGroupName
            reviews {
              date
              fieldGroupName
              review
              rating
              name
              heading
            }
            leftSideImage {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
